import { Select as Menu, Option as MenuItem, useSelect as useMenu } from '@econsult/econsult-ui/dist/components/Select';
import { Caret, MenuButton, MenuItems, UserActions } from '@econsult/econsult-ui/dist/components/TopBar/TopBarStyles';
import { useWelcomeModal, WelcomeModalProvider } from 'components/Modal/WelcomeModalContext';
import { STRINGS } from 'config';
import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { redirectUserToLogoutScreen } from 'store/action/auth';
import { useAppDispatch, useAppState } from 'store/configureStore';

interface TopBarUserActionsProps {
  children?: ReactNode;
}

export const TopBarUserActions: FC<TopBarUserActionsProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const {
    app: { user, roles },
    featureFlags: { ENABLE_SHOW_WELCOME_MODAL },
  } = useAppState();
  const navigate = useNavigate();
  const {
    toggleSelect: toggleUserSelect,
    selectContext: userSelectContext,
    isOptionsListOpen: isUserSelectOpen,
  } = useMenu();

  const { openWelcomeModal } = useWelcomeModal();

  const isToolbarUser = roles?.includes(STRINGS.TOOLBAR.ROLE);

  const handleLogout = () => {
    dispatch({ type: STRINGS.REDUCERS.APP.RESET_ALL_STATE });
    redirectUserToLogoutScreen();
  };

  return (
    <WelcomeModalProvider>
      <UserActions>
        {children}
        <Menu closeOnClickOutside selectContext={userSelectContext} automationName="TopBarUserMenuDropdown">
          <MenuButton onClick={toggleUserSelect} isActive={isUserSelectOpen} data-hj-suppress>
            {user.name}
            <Caret />
          </MenuButton>
          <MenuItems>
            {!isToolbarUser ? (
              <MenuItem onClick={handleLogout} data-automation="Logout_button">
                Log out
              </MenuItem>
            ) : (
              <></>
            )}
            <MenuItem onClick={() => navigate('/cookiepolicy')} data-automation="cookie_policy_page_button">
              Cookie policy
            </MenuItem>
            <MenuItem
              onClick={() => openWelcomeModal()}
              data-automation="welcome_info_button"
              style={{ display: !ENABLE_SHOW_WELCOME_MODAL && 'none' }}
            >
              Welcome info
            </MenuItem>
          </MenuItems>
        </Menu>
      </UserActions>
    </WelcomeModalProvider>
  );
};
